import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';
const url = process.env.REACT_APP_BANKVERIFY_URL;

export const GetAllDevice = async (setIsLoading, setData, handleAlertOpen) => {
  try {
    setIsLoading(true);
    const response = await axios.get(`${url}procurement/procurements`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      },
      params: {
        get_all: true
      }
    });
    setData(response.data);
    setIsLoading(false);
  } catch (error) {
    // console.log(error);
    setIsLoading(false);
    handleAlertOpen(
      error.response && error.response.data.error ? error.response.data.error : 'Something went wrong while getting device',
      'error'
    );
  }
};

export const PostPurchaseRequest = async (data, setIsLoading, handleAlertOpen,handleClose) => {
    try {
        const postdata = {
            "device_id": data.modal_number,
            "quantity": data.quantity,
            "deadline": data.date,
            "remarks": data.remarks
        }
        setIsLoading(true)
        await axios.post(`${url}procurement/purchase/add`, postdata, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            }
        })
        .then((res)=>{
            setIsLoading(false)
            handleAlertOpen(res.data.message, "success")
            handleClose()
            setTimeout(()=>{
                window.location.reload()
            },1500)
        })
        
    }
    catch (error) {
        // console.log(error);

    setIsLoading(false);
    handleAlertOpen(
      error.response && error.response.data.error ? error.response.data.error : 'Something went wrong while sending purchase request',
      'error'
    );
  }
};

export const GetRequestList = async (Filter,setIsLoading, filter, setData, handleAlertOpen,page,UserRole) => {
  

  
//  console.log("Filter",FilterData);

  try {
    setIsLoading(true);
    await axios
      .get(`${url}/procurement/purchase`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params: {
          page:page,
          status: filter==='All'?"":filter,
          // get_all: filter === 'All' ? true : false,
          from_date: Filter.from_date.split('-').reverse().join('-'),
          to_date: Filter.to_date.split('-').reverse().join('-'),
          device: Filter.device,
          ...UserRole
        }
      })
      .then((res) => {
        setIsLoading(false);
        setData(res.data);
      });
  } catch (error) {
    setIsLoading(false);
    TokenLogout(error)
    handleAlertOpen(
      error.response && error.response.data.error ? error.response.data.error : 'Something went wrong while getting request list',
      'error'
    );
  }
};

export const ApproveRequest = async (isLoading, data, handleAlertOpen, handleClose, getRequestList) => {
  try {
    isLoading(true);
    await axios
      .post(`${url}procurement/purchase/update`, data, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        isLoading(false);
        handleAlertOpen(res.data.message, 'success');
        handleClose();
        getRequestList();
      });
  } catch (error) {
    isLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong', 'error');
  }
};
